module.exports = __webpack_public_path__ + "static/009-4128b88e31caa7845c8f3d37840bc398.jpg";